<template>
  <div>
    <loading 
      :active.sync="isLoading"
      :can-cancel="canCancel"
      :is-full-page="fullPage" 
      :color="color"
      :loader="loader"
      :z-index="zindex"
    ></loading>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
export default {
  name: 'customLoading',
  components: {
    Loading
  },
  props: {
    zindex: {
      type: Number,
      default: 9999
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    canCancel: {
      required: false,
      type: Boolean,
      default: false
    },
    fullPage: {
      required: false,
      type: Boolean,
      default: true
    },
    color: {
      required: false,
      type: String,
      default: '#fe0000'
    },
    loader: {
      required: false,
      type: String,
      default: 'dots'
    }
  }
}
</script>

<style>

/* TODO:: Burası düzeltilecek */
  /* .vld-overlay .vld-icon, .vld-parent {
      position: absolute !important;
      top: 200px  !important;
  } */

</style>
